import { Avatar, AvatarProps } from '@mui/material'

type TMuiAvatarProps = AvatarProps

const MuiAvatar = (props: TMuiAvatarProps) => <Avatar {...props} />

export default MuiAvatar
